import React from 'react'
//@ts-ignore
import s from './ViewPlan.module.scss'
import { useSelector } from 'react-redux'
import { getKeySectionActive, getKeyViewActive, getValueOption, valueOption } from '../../store/selectors/selectors'

export const ViewPlan = () => {
    const keyViewActive: string = useSelector(getKeyViewActive)
    const KeySectionActive: string = useSelector(getKeySectionActive)

    let isActive = false;
    if (keyViewActive === 'Plan') isActive = true

    let selectAddPorch: valueOption = useSelector(state => getValueOption({ idOptions: 'BaseOption_AddPorch' })(state));
    let selectAddLoft: valueOption = useSelector(state => getValueOption({ idOptions: 'BaseOption_AddLoft' })(state));



    if (KeySectionActive === 'BaseOptions' && (!!selectAddPorch['selectValue'] || !!selectAddLoft['selectValue'])) isActive = true

    return (
        <>
            {isActive && (<div className={s.plan}> <img src="/assets/plan.jpg" alt="" /> </div>)}
        </>
    )
}
